import { Injectable, Inject } from '@angular/core';
import { SharedContentClient, SharedContent } from '../api/DixApiClient';
import { WorkspaceServiceService } from './workspace-service.service';
import * as $ from "jquery";
import { HttpClient } from "@angular/common/http";
import { Utils } from '../utils';

export enum ShareProvider
{
  Facebook = 'facebook',
  Linkedin = 'linkedin',
  Twitter = 'twitter'
}

export var ShareProviders = Object.keys(ShareProvider).map(k => (ShareProvider as any)[k]) as string[];

export var ProviderSharerUrl: { [key: string]: string } = 
{
  'facebook': 'https://www.facebook.com/sharer/sharer.php?u=', 
  'linkedin': 'https://www.linkedin.com/sharing/share-offsite/?url=',
  'twitter': 'https://twitter.com/intent/tweet?via=PremiereTrade&text={text}&hashtags=PremiereTrade,Forex,ForexTrading&url='
};

@Injectable({
  providedIn: 'root'
})
export class ShareService {

  //TODO replace replace("/home")
  get baseUrl()
  {
    return location.protocol + '//' + location.host;
  }

  get shareProviders()
  {
    return ShareProviders;
  }

  
  public lastPosts: { [shareProvider: string]: SharedContent} = {};

  constructor(@Inject(SharedContentClient) public sharedContentClient: SharedContentClient, 
  @Inject(WorkspaceServiceService) public workspaceService: WorkspaceServiceService,
  private http: HttpClient) { (window as any).shareService = this; }

  public shareWithSvg(shareProvider: ShareProvider | string, text: string, svg?: string, email?: string, targetFormat = "png", quality = 50) 
  {
    email = email || this.workspaceService.data.getCurrentUserName() || undefined;
    if(email == null)
      return;
    let uid = (new Date().getTime() + email).replace(/\W/g, "");
    this.openSharePopup(this.getSharePopupUrl(uid, this.getShareUrl(shareProvider, uid, text)));
    let res = this.createSocialPostWithSvg(uid, shareProvider, text, email, svg || this.getSvgStringForSocialMedia(), targetFormat, quality);
    res.done(() => this.updateLastPosts())
    return res;
  }

  public getPostImageUrl(sharedContent: SharedContent)
  {
    return this.baseUrl + "/api/SharedContent/Image/" + sharedContent.uid;
  }

  public updateLastPosts()
  {
    Utils.waitFor(() => this.workspaceService.data.loggedIn, () =>
    {
      ShareProviders.forEach(sp =>
      {
          this.sharedContentClient.getLatestUserPostByProvider(this.workspaceService.data.getCurrentUserName(), sp).toPromise().then(sc =>
          {
              if(sc) this.lastPosts[sp] = sc;
          });
      });
    });
  }

  public openSharePopup(shareUrl: string)
  {
    window.open(shareUrl, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
  }

  public getSharePopupUrl(uid: string, shareUrl: string)
  {
      return this.baseUrl + "/Preloader?uid=" + uid + "&targetUrl=" + encodeURIComponent(shareUrl);
  }

  public getShareUrl(shareProvider: ShareProvider | string, uid: string, text: string)
  {
    let sharerUrl = this.getProviderSharerUrl(shareProvider);
    return sharerUrl.replace('{text}', encodeURIComponent(text))  + this.baseUrl + "/Preview/" + uid;
  }

  public getProviderSharerUrl(shareProvider: ShareProvider | string)
  {
    return ProviderSharerUrl[shareProvider];
  }

  public createSocialPostWithSvg(uid?: string | null | undefined, provider?: string | null | undefined, text?: string | null | undefined, email?: string | null | undefined, svg?: string | null | undefined, targetFormat?: string | null | undefined, targetQuality?: number | undefined) 
  {
    return $.post(this.baseUrl + "/api/SharedContent/CreateSocialPostWithSvg", 
      { uid: uid, provider: provider, text: text, email: email, svg: svg, targetFormat: targetFormat, targetQuality: targetQuality});
    //swagger method doesn't work
    //this.sharedContentClient.createSocialPostWithSvg(uid, shareProvider, text, email, svg || this.getSvgStringForSocialMedia(), targetFormat, quality);
  }

  public getSvgStringForSocialMedia() : string
  {
      const svg = document.querySelector('.chart-selected svg') || document.querySelector('.chart-container svg') as SVGAElement;

      if(!svg)
          return '<svg></svg>';

      const svgClone = svg.cloneNode(true) as SVGElement;

      //set size in px instead %
      svgClone.setAttribute('width', (svg as any).width.baseVal.value);
      svgClone.setAttribute('height', (svg as any).height.baseVal.value);

      //remove tspans wich are problematic for .NET SVG Rendering Engine
      svgClone.querySelectorAll('tspan').forEach(tspan => 
      {
          const parent = tspan.parentNode as Element; 
          const text = tspan.innerHTML; 
          parent.removeChild(tspan); 
          parent.innerHTML = text; 
      });
      return svgClone.outerHTML;
  }
}
